import React from 'react';
import $ from 'jquery';
import Language from '../services/Language.js';
import utils from '../services/utils.js';
import AppModalWidget from './AppModalWidget.js';

let inst;

class CryptoModalVerificationsSucces extends React.Component {
    constructor(props) {
        super(props);
        if (!inst) {
            this.url = '';
            this.sendedData = {};
            this.modalObject = null;
            this.settings = {};

            inst = this;
        }

        this.showModal = this.showModal.bind(this);

        return inst;
    }

    callback() { }

    showModal() {
        const modalSettings = {
            closeOnBgClick: true,
            wrapContentClass: "crypto-modal-verifications-succes"
        };

        this.modalObject = $("<div />", {
            "class": "crypto-modal-verifications-succes__body"
        });

        this.modalObject.html(
            `<div class="crypto-modal-verifications-succes__form">
                <div class="crypto-modal-verifications-succes__desc">
                    <div class="crypto-modal-verifications-succes__img">
                        <img src="/img/pages/crypto-verification/img-verifications-circle-check.svg" alt="succes" />
                    </div>
                    <p class="crypto-modal-verifications-succes__text">
                        ` + Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_SUCCES_TITLE') + `
                    </p>
                </div>

                <div class="crypto-modal-verifications-succes__bottom">
                    <button class="button button--green jsCloseModal crypto-modal-verifications-succes__button" type="button">` + Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_SUCCES_BTN') + `</button>
                </div>
            </div>`
        );

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }

    afterShowHandler() { }

    recentAnimation() { }

    close(cb) {
        if (this.modalObject) {
            AppModalWidget.close(cb);
        }
    }
}

export default new CryptoModalVerificationsSucces();
